import type { VisitTap } from '../documents/visitTaps';

/**
 * The Work routes the web and the phone both call (T3226): the My Jobs board
 * and a tap on a visit, and the Service form's site options. One builder each,
 * encoding every id. 🔨 Relative to the API's own root, so no path repeats the
 * base's `/api`.
 */
export const MY_JOBS_PATH = '/work/my-jobs';
export const SERVICE_REQUESTS_PATH = '/work/requests';

/** The three presses on a visit, as the route names them. */
const TAP_SEGMENTS = { OnMyWay: 'on-my-way', Arrived: 'arrived', Leaving: 'leaving' } as const satisfies Record<VisitTap, string>;

/** The viewer's own board in their zone; the web's `employmentId` reads one person's board where the viewer may (decision 2910). */
export function myJobsPath(timeZone: string, employmentId?: string | null): string {
  return `${MY_JOBS_PATH}?timeZone=${encodeURIComponent(timeZone)}${employmentId ? `&employmentId=${encodeURIComponent(employmentId)}` : ''}`;
}

/** On My Way, Arrived or Leaving on one visit, always the viewer's own (decision 1982). */
export function myJobsTapPath(visitId: string, tap: VisitTap): string {
  return `${MY_JOBS_PATH}/visits/${encodeURIComponent(visitId)}/${TAP_SEGMENTS[tap]}`;
}

/** The sites the Service form offers for an Account, and the contacts of the chosen site where one is named (decision 1912). */
export function serviceRequestOptionsPath(companyId: string, siteId?: string | null): string {
  return `${SERVICE_REQUESTS_PATH}/options?companyId=${encodeURIComponent(companyId)}${siteId ? `&siteId=${encodeURIComponent(siteId)}` : ''}`;
}
